import httpRequest from '../../common/lib/http-request';

// *******************
// CMS SERVICES
// *******************

function getMenus(language, privateAccess) {
    const privateAccessUrl = !privateAccess ? '?privateAccess=false' : '';
    return httpRequest({
        url: '/Cms/menu/' + language + privateAccessUrl,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function getRegimentoPageContent() {
    return httpRequest({
        url: '/Cms/content/regimento',
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function getMeetingNoteList() {
    return httpRequest({
        url: '/Cms/content/atas',
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function getMeetingNotePageContent(fileRef) {
    return httpRequest({
        url: '/Cms/content/file/' + fileRef,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}


const CmsService = { getMenus, getRegimentoPageContent, getMeetingNoteList, getMeetingNotePageContent }

export default CmsService;